export default __webpack_public_path__ + "static/media/Guru-Parampara-32.a8ef6f03.png";